(function ($, Drupal, drupalSettings) {
  "use strict";

  /*
  | ----------------------------
  | Header
  | ----------------------------
  */
  var $header = $("#main-header");
  var $mobileMenu = $("#mobile-menu");
  var $burgerBtn = $("#burger-toggle");
  var $closeBtn = $("#mobile-close");

  function getHeaderHeight() {
    var h = $header.outerHeight();
    return $("body").hasClass("user-logged-in") ? h + 0 : h;
  }

  function applyHeaderOffset() {
    var h = getHeaderHeight();
    $("main").css("padding-top", h + "px");
    $mobileMenu.css("top", h + "px");
  }

  applyHeaderOffset();
  $(window).on("resize.header", applyHeaderOffset);

  // Scroll shadow
  $(window).on("scroll.header", function () {
    $header.toggleClass("header--scrolled", $(this).scrollTop() > 10);
  });

  // Burger toggle
  $burgerBtn.on("click", function () {
    var opening = !$header.hasClass("header--open");
    $header.toggleClass("header--open");
    $mobileMenu.toggleClass("is-open");
    $burgerBtn.attr("aria-expanded", String(opening));
    $mobileMenu.attr("aria-hidden", String(!opening));
    $("body").toggleClass("mobile-menu-open", opening);
  });

  // Close button inside mobile menu
  $closeBtn.on("click", function () {
    $header.removeClass("header--open");
    $mobileMenu.removeClass("is-open").attr("aria-hidden", "true");
    $burgerBtn.attr("aria-expanded", "false");
    $("body").removeClass("mobile-menu-open");
  });

  // Close on any nav link click inside mobile menu
  $mobileMenu.on("click", "a", function () {
    // Don't close when tapping the lang switcher links
    if ($(this).hasClass("language-link")) return;
    $header.removeClass("header--open");
    $mobileMenu.removeClass("is-open").attr("aria-hidden", "true");
    $burgerBtn.attr("aria-expanded", "false");
    $("body").removeClass("mobile-menu-open");
  });

  /*
  | ----------------------------
  | Search form
  | ----------------------------
  */
  $(".search-toggle").on("click", function () {
    $(".block-rkpt-search-form-block").toggleClass("active");
    $("body").removeClass("open-menu");
    $(".account").removeClass("active");
  });

  /* 
  | ----------------------------
  | Swiper setup
  | ----------------------------
  */

  function setupSwiper(width, element, options) {
    // breakpoint where swiper will be destroyed
    var breakpoint = window.matchMedia("(min-width:" + width + ")");

    // keep track of swiper instances to destroy later
    var mySwiper;

    var breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) {
          mySwiper.destroy(true, true);
          // or/and do nothing
          return;
        }

        // else if a small viewport and double column layout needed
      } else {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    var enableSwiper = function () {
      mySwiper = new Swiper(element, options);
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  }

  /*
  | ----------------------------
  | Program cards — touch/click toggle
  | ----------------------------
  */
  if ($(".program-card").length) {
    var hasHover = window.matchMedia("(hover: hover)").matches;

    function resetRainbow($stage) {
      var $cards = $stage.find(".program-card");
      $cards.removeClass("is-active");
      $cards.first().addClass("is-active");
    }

    // Desktop: entering a card clears is-active so CSS hover takes over cleanly
    $(document).on(
      "mouseenter",
      ".programs-rainbow__stage .program-card",
      function () {
        if (hasHover) {
          $(".program-card").removeClass("is-active");
        }
      },
    );

    // Desktop: mouse leaves the section → reset to first card
    $(document).on("mouseleave", ".programs-rainbow__stage", function () {
      if (hasHover) {
        resetRainbow($(this));
      }
    });

    // Both: tap/click a card to activate it (touch primary, desktop fallback)
    $(document).on("click", ".program-card", function () {
      var $card = $(this);
      var alreadyActive = $card.hasClass("is-active");
      $(".program-card").removeClass("is-active");
      if (!alreadyActive) {
        $card.addClass("is-active");
      }
    });

    // Both: click/tap outside the stage → reset to first card
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".programs-rainbow__stage").length) {
        $(".programs-rainbow__stage").each(function () {
          resetRainbow($(this));
        });
      }
    });
  }

  //Accordion
  if ($(".accordion").length) {
    $(".accordion__item .field__label").on("click", function () {
      $(this).parents(".accordion__item").toggleClass("show");
    });
  }

  //Tabs
  if ($(".tabs").length) {
    $(".tabs__item .field__label").on("click", function () {
      if ($(window).width() > 1024) {
        $(".tabs__item").removeClass("active");
        $(this).parents(".tabs__item").addClass("active");
      } else {
        $(this).parents(".tabs__item").toggleClass("active");
      }
    });
  }
  /*
  | ----------------------------
  | Schools page — find nearest (geolocation)
  | ----------------------------
  */
  if ($("#find-nearest-btn").length) {
    var $findBtn = $("#find-nearest-btn");
    var $resultBox = $("#nearest-result");
    var $nearestName = $("#nearest-name");
    var $nearestAddr = $("#nearest-address");

    function haversineDistance(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var dLat = ((lat2 - lat1) * Math.PI) / 180;
      var dLng = ((lng2 - lng1) * Math.PI) / 180;
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    $findBtn.on("click", function () {
      if (!navigator.geolocation) {
        return;
      }
      $findBtn.addClass("is-searching").prop("disabled", true);
      $resultBox.attr("hidden", true);
      $(".school-teaser").removeClass("is-nearest");

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var userLat = pos.coords.latitude;
          var userLng = pos.coords.longitude;
          var minDist = Infinity;
          var $closest = null;

          $(".school-teaser[data-lat]").each(function () {
            var lat = parseFloat($(this).data("lat"));
            var lng = parseFloat($(this).data("lng"));
            var dist = haversineDistance(userLat, userLng, lat, lng);
            if (dist < minDist) {
              minDist = dist;
              $closest = $(this);
            }
          });

          $findBtn.removeClass("is-searching").prop("disabled", false);

          if ($closest) {
            $closest.addClass("is-nearest");
            $nearestName.text($closest.data("school-name"));
            $nearestAddr.text($closest.data("school-address"));
            $resultBox.removeAttr("hidden");
            setTimeout(function () {
              $closest[0].scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }, 400);
          }
        },
        function () {
          $findBtn.removeClass("is-searching").prop("disabled", false);
        },
        { enableHighAccuracy: true, timeout: 10000 },
      );
    });
  }

  /*
  | ----------------------------
  | Node 13 — mobile tabs: Νέα / Άρθρα (≤768px)
  | ----------------------------
  */
  if ($("body").hasClass("node-id-13")) {
    var $articlesBlock = $("#block-rkpt-views-block-articles-block-1");
    var $newsBlock = $("#block-rkpt-views-block-news-block-1");

    if ($articlesBlock.length && $newsBlock.length) {
      var newsCount = $newsBlock.find(".views-row").length;
      var articlesCount = $articlesBlock.find(".views-row").length;

      var $tabBar = $(
        '<div class="m4k-tab-bar">' +
          '<button class="m4k-tab-btn is-active" data-target="news">Νέα <span class="m4k-tab-count">(' +
          newsCount +
          ")</span></button>" +
          '<button class="m4k-tab-btn" data-target="articles">Άρθρα <span class="m4k-tab-count">(' +
          articlesCount +
          ")</span></button>" +
          "</div>",
      );

      $articlesBlock.before($tabBar);
      $newsBlock.addClass("is-tab-active");

      $tabBar.on("click", ".m4k-tab-btn", function () {
        var target = $(this).data("target");
        $tabBar.find(".m4k-tab-btn").removeClass("is-active");
        $(this).addClass("is-active");
        $newsBlock.toggleClass("is-tab-active", target === "news");
        $articlesBlock.toggleClass("is-tab-active", target === "articles");
      });
    }
  }

  /*
  | ----------------------------
  | Banana Hero — scrolling rows + GSAP title animation
  | ----------------------------
  */
  Drupal.behaviors.bananaHero = {
    attach: function (context, settings) {
      var bananaHeros = context.querySelectorAll
        ? context.querySelectorAll("[data-banana-hero]")
        : [];

      bananaHeros.forEach(function (hero) {
        if (hero.hasAttribute("data-banana-hero-attached")) {
          return;
        }
        hero.setAttribute("data-banana-hero-attached", "true");

        // ── Video autoplay ──────────────────────────────────────
        var videos = hero.querySelectorAll("video");
        videos.forEach(function (video) {
          video.removeAttribute("controls");
          video.setAttribute("autoplay", "");
          video.setAttribute("loop", "");
          video.setAttribute("muted", "");
          video.setAttribute("playsinline", "");
          video.muted = true;

          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function () {});
          }

          if ("IntersectionObserver" in window) {
            var videoObserver = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting) {
                    entry.target.play().catch(function () {});
                  } else {
                    entry.target.pause();
                  }
                });
              },
              { threshold: 0.1 },
            );
            videoObserver.observe(video);
          }
        });

        // ── GSAP title animation ────────────────────────────────
        var words = hero.querySelectorAll(".banana-hero__word");

        if (words.length > 0 && typeof gsap !== "undefined") {
          gsap.set(words, { opacity: 0, y: 30, scale: 0.9 });
          gsap.to(words, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            delay: 0.5,
            ease: "power3.out",
            stagger: 0.15,
            onComplete: function () {
              words.forEach(function (word) {
                word.classList.add("is-visible");
              });
            },
          });
        } else {
          words.forEach(function (word) {
            word.classList.add("is-visible");
            word.style.opacity = "1";
            word.style.transform = "none";
          });
        }

        // ── Dynamic animation duration from data-duration ───────
        var rows = hero.querySelectorAll(".banana-hero__row");
        rows.forEach(function (row) {
          var duration = row.getAttribute("data-duration");
          if (duration) {
            var track = row.querySelector(".banana-hero__track");
            if (track) {
              track.style.setProperty(
                "animation-duration",
                duration + "s",
                "important",
              );
              track.style.setProperty(
                "animation-play-state",
                "running",
                "important",
              );
              track.style.setProperty(
                "animation-iteration-count",
                "infinite",
                "important",
              );
            }
          }
        });

        // ── Optional ScrollTrigger parallax on the rows wrapper ─
        if (
          typeof gsap !== "undefined" &&
          typeof ScrollTrigger !== "undefined"
        ) {
          gsap.registerPlugin(ScrollTrigger);
          var rowsWrapper = hero.querySelector(".banana-hero__rows");
          if (rowsWrapper) {
            gsap.set(rowsWrapper, { rotation: -5, scale: 1.2 });
            gsap.to(rowsWrapper, {
              y: -40,
              ease: "none",
              scrollTrigger: {
                trigger: hero,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
              },
            });
          }
        }
      });
    },
  };

  /*
  | ----------------------------
  | Schools map — Leaflet (Drupal behavior, fires after Leaflet loads)
  | ----------------------------
  */
  Drupal.behaviors.locationsMap = {
    attach: function (context, settings) {
      var mapEl = document.getElementById("locations-map");
      if (!mapEl || !window.L || mapEl._leaflet_id) {
        return;
      }

      var map = L.map(mapEl, {
        center: [38.5, 23.5],
        zoom: 6,
        scrollWheelZoom: false,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      var schoolIcon = L.icon({
        iconUrl:
          "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png",
        shadowUrl:
          "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      document
        .querySelectorAll(".school-teaser[data-lat]")
        .forEach(function (card) {
          var lat = parseFloat(card.dataset.lat);
          var lng = parseFloat(card.dataset.lng);
          var name = card.dataset.schoolName || "";
          var address = card.dataset.schoolAddress || "";
          var phone = card.dataset.schoolPhone || "";
          var url = card.dataset.schoolUrl || "#";

          var marker = L.marker([lat, lng], { icon: schoolIcon }).addTo(map);

          var popup =
            '<div style="text-align:center;padding:8px;min-width:180px">' +
            '<h3 style="font-weight:bold;color:#ee2b8c;font-size:16px;margin:0 0 8px">' +
            name +
            "</h3>" +
            (address
              ? '<p style="font-size:13px;color:#737b8c;margin:0 0 4px">' +
                address +
                "</p>"
              : "") +
            (phone
              ? '<p style="font-size:13px;color:#737b8c;margin:0 0 12px">' +
                phone +
                "</p>"
              : "") +
            '<a href="' +
            url +
            '" style="display:inline-block;background:linear-gradient(135deg,#ee2b8c,#8042d7);color:white;padding:8px 16px;border-radius:20px;text-decoration:none;font-size:13px;font-weight:600">Περισσότερα</a>' +
            "</div>";

          marker.bindPopup(popup);
        });
    },
  };

  Drupal.behaviors.programsRainbowSwipe = {
    attach: function (context) {
      $(".programs-rainbow__stage", context).each(function () {
        var $stage = $(this);
        if ($stage.data("swipe-init")) return;
        $stage.data("swipe-init", true);

        var $cards = $stage.find(".program-card");

        // Ensure a real is-active exists so swipe always has an anchor
        if (!$cards.filter(".is-active").length) {
          $cards.first().addClass("is-active");
        }

        var startX = 0;

        $stage[0].addEventListener(
          "touchstart",
          function (e) {
            startX = e.touches[0].clientX;
          },
          { passive: true },
        );

        $stage[0].addEventListener(
          "touchend",
          function (e) {
            var deltaX = e.changedTouches[0].clientX - startX;
            if (Math.abs(deltaX) < 40) return;

            var $active = $cards.filter(".is-active");
            var idx = $active.length ? $cards.index($active) : 0;
            var newIdx =
              deltaX < 0
                ? Math.min(idx + 1, $cards.length - 1)
                : Math.max(idx - 1, 0);

            $cards.removeClass("is-active");
            $cards.eq(newIdx).addClass("is-active");
          },
          { passive: true },
        );
      });
    },
  };

  // School form - pre-select and lock location to the current school
  (function () {
    var formContainer = document.querySelector(".form[data-school-location]");
    if (!formContainer) return;

    var schoolId = formContainer.getAttribute("data-school-location");
    if (!schoolId) return;

    var locationSelect = document.getElementById("edit-location");
    if (!locationSelect) return;

    // Pre-select the matching option
    locationSelect.value = schoolId;
    locationSelect.dispatchEvent(new Event("change", { bubbles: true }));

    // Lock — disabled selects don't submit, so add a hidden input for the value
    locationSelect.disabled = true;

    var hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "location";
    hidden.value = schoolId;
    locationSelect.parentNode.appendChild(hidden);
  })();
})(jQuery, Drupal, drupalSettings);
